import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import ServicioAsignadoTable from './ServicioAsignadoTable';
import WindowHeader from '../../../commons/WindowHeader';

const ServicioAsignado = (props: any) => {

    const { empresaServicios } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <>
            <WindowHeader title="Servicios Asignados"></WindowHeader>
            <ServicioAsignadoTable empresaServicios={empresaServicios}></ServicioAsignadoTable>
        </>

    );
}

export default ServicioAsignado;
